import React, {FC} from 'react';

import {SubsectionTable} from 'components/table/subsection-table';
import {IPageTemplateProps} from 'pages';

export const SubsectionTablePage: FC<IPageTemplateProps> = ({
    entityName,
    url,
    hideTitle,
    entityType,
}: IPageTemplateProps) => (
    <SubsectionTable
        entityName={entityName}
        entityType={entityType}
        url={url}
        hideTitle={hideTitle}
    />
);
